import { EngagementDto } from "@/@client/Theasoft_ApiServer_Contracts"
import { DetailsCard } from "@/routes/app/-components/details-card"
import { getFormattedDatePeriod } from "@/utils/get-formatted-date"
import { LabeledValue } from "@components/default-list/labeled-value"
import { DefaultListItem } from "@components/default-list/list-item"
import { Text } from "@mantine/core"
import { useTranslation } from "react-i18next"

interface Props {
  engagements: EngagementDto[]
}

export function ContractEngagementsCard({ engagements }: Props) {
  const { t } = useTranslation("app_server")
  if (engagements.length === 0) return null

  return (
    <DetailsCard stackProps={{ gap: "xs" }} title={t("Fees")}>
      {engagements.map((engagement, i) => (
        <React.Fragment key={i}>
          <Text fz={"lg"} fw={"bold"}>
            {engagement.production && engagement.role
              ? `${engagement.production}/${engagement.role}`
              : engagement.production || engagement.role}
          </Text>
          {(engagement.start || engagement.end) && (
            <DefaultListItem>
              <LabeledValue
                label={t("TimePeriod")}
                value={getFormattedDatePeriod({
                  start: engagement.start,
                  end: engagement.end,
                })}
              />
            </DefaultListItem>
          )}
          {engagement.salaryRules.map((salaryRule, i) => (
            <DefaultListItem key={i}>
              <LabeledValue
                label={salaryRule.name}
                value={`${salaryRule.value} ${t(salaryRule.type)}`}
              />
            </DefaultListItem>
          ))}
        </React.Fragment>
      ))}
    </DetailsCard>
  )
}
